// material-ui
import {useTheme} from '@mui/material/styles';
import {Avatar, Box, FormControl, Grid, MenuItem, Select} from '@mui/material';

// project imports
import LogoSection from '../LogoSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
import {useDispatch, useSelector} from 'store';
import {openDrawer} from 'store/slices/menu';
import RechargeSection from "./RechargeSection";
import ActivitySection from "./ActivitySection";

// assets
import {IconMenu2} from '@tabler/icons';
import ConsolidateSection from "./ConsolidateSection";
import {Company} from "../../../types/type/activities-types";
import React, {useEffect, useState} from "react";
import useConfig from "../../../hooks/useConfig";
import {getLastConsolidate} from "../../../store/actions/activites.actions";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

interface HeaderProps {
    showCompanyField?: boolean;
}

const Header = ({showCompanyField}: HeaderProps) => {
    const theme = useTheme();
    const {onChangeCompany, company, onChangeReloadPage, reloadPage} = useConfig();

    const dispatch = useDispatch();
    const {drawerOpen} = useSelector((state) => state.menu);
    const companyObj = useSelector((state) => state.company);
    const [companiesArray, setCompaniesArray] = useState<Company[]>([])
    const {lastConsolidate} = useSelector((state) => state.activity);

    const [lastConsolidateLocal, setLastConsolidateLocal] = useState<any[]>([])

    useEffect(() => {
        setLastConsolidateLocal(lastConsolidate)
    }, [lastConsolidate])

    useEffect(() => {
        setCompaniesArray(companyObj.company)
    }, [companyObj.company]);

    useEffect(() => {
        const init = async () => {
            await dispatch(getLastConsolidate(company));
        }
        init()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            {/* logo & toggler button */}
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Box component="span" sx={{display: {xs: 'none', md: 'block'}, flexGrow: 1}}>
                    <LogoSection/>
                </Box>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                        color: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.secondary.main : theme.palette.secondary.dark,
                            color: theme.palette.mode === 'dark' ? theme.palette.secondary.light : theme.palette.secondary.light
                        }
                    }}
                    onClick={() => dispatch(openDrawer(!drawerOpen))}
                    color="inherit"
                >
                    <IconMenu2 stroke={1.5} size="1.3rem"/>
                </Avatar>
            </Box>
            <Box sx={{flexGrow: 1}}>
                {
                    true && (
                        <Grid item>
                            <FormControl sx={{m: 1, pl: 1}}>
                                <Select
                                    id="site"
                                    name="site"
                                    size={'small'}
                                    value={company == '' ? companiesArray[0] : company}
                                    onChange={(values) => {
                                        // @ts-ignore
                                        onChangeCompany(values.target.value)
                                    }}
                                    inputProps={{'aria-label': 'Without label'}}
                                >
                                    {companiesArray.map((column: Company, index: number) => (
                                        <MenuItem key={index} value={column.id}>
                                            {column.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )
                }
            </Box>
            <Box sx={{flexGrow: 1}}/>

            <Box sx={{display: {xs: 'none', sm: 'block'}}}>
                <ConsolidateSection/>
            </Box>

            <Box sx={{display: {xs: 'none', sm: 'block'}}}>
                <RechargeSection/>
            </Box>

            <Box sx={{display: {xs: 'none', sm: 'block'}}}>
                <ActivitySection/>
            </Box>

            <ProfileSection lastConsolidate={lastConsolidateLocal} companiesArray={companiesArray}/>

            {/* mobile header */}
            <Box sx={{display: {xs: 'block', sm: 'none'}}}>
                <MobileSection/>
            </Box>
        </>
    );
};

export default Header;